import { Presenter, HeaderView } from "common/components/table/cells/generic";

export class CheckboxPresenter extends Presenter {
    itemClassName = () => "checkbox-cell";
    
    contentTemplate = ({ selected }) => `<input type='checkbox' ${selected && "checked=checked"} />`;
    
    itemContent(column, content) {
        return this.contentTemplate({
            selected: content
        });
    }
}

export const CheckboxHeaderView = HeaderView.extend({
    type: "text",
    className: "checkbox-column-header",
    events: {
        "change input[type='checkbox']": "toggleCheckAll"
    },
    template: () => "<input type='checkbox'>",
    
    toggleCheckAll() {
        if (this.checked === true) {
            // Uncheck all
            this.trigger("select", this, "none");
            this.checked = false;
        } else {
            // Check all
            this.trigger("select", this, "all");
            this.checked = true;
        }
    }
});
